import { allEventTypes, checkStr, copyRectEvents, copyColEvents, filterPcEvents } from "./utils"
import router from "@/router"
import { v1 } from "uuid"
const uuid = { v1 }
import eventPlugins from "./eventPlugins/index"
import { execPlugins } from "utils"

/**
 * @constructor
 * 该类包含了页面中所有事件的存储、执行、全部组件上下文的存储
 */
class Event {
  constructor() {
    this.eventBus = {} //存储页面中的所有事件,数据结构见eventBus_mock
    this.contexts = {} //存储全局所有的组件的this
    this.fromContext = null //执行事件时 触发事件的组件的this
    this.toContext = null //执行事件时 响应事件的组件的this
    //👇判断执行器变量是否合法的正则,执行器变量用于事件变量监听时,事件变量指定为某个值才会触发的场景下使用
    this.execRE = /\{\{((?:.|\r?\n)+?)\}\}/g
    this.variableRE = /\(\(((?:.|\r?\n)+?)\)\)/g //判断事件变量是否合法的正则
    this.toContext1 = null
  }
  /**
   * 将组件中的this保存到事件总线中
   * @param {object} ids 组件的id
   * @param {object} context 组件中的this
   */
  addContext(ids, context) {
    const idsStr = this.getIdsByStrId(ids)
    if (!this.contexts[this.env()]) this.contexts[this.env()] = {}
    this.contexts[this.env()][idsStr] = context
  }
  /**
   *新增事件
   * @param {object} param 新增事件的参数
   * @param {string} type 新增事件的类型
   * @param {object} editParam 编辑事件的参数,如果有该参数,则说明是在二次编辑事件
   */
  add(param, type, editParam) {
    const tarEvent = this.getTarEvent(param)
    let eventOpt
    //具体到事件类型 事件名的一个数组
    switch (type) {
      //初始化组件配置项事件参数
      case "componentOption":
        eventOpt = this.addComponentOption(param, tarEvent)
        break
      //初始化组件显示隐藏事件参数
      case "componentShow":
        eventOpt = this.addComponentShow(param, tarEvent)
        break
      //初始化浏览器事件参数
      case "window":
        eventOpt = this.addWindow(param, tarEvent)
        break
      case "scroll":
        eventOpt = this.addScroll(param, tarEvent)
        break
      default:
        break
    }
    if (eventOpt) {
      if (editParam) {
        eventOpt.lifeCycle = editParam.lifeCycle
        tarEvent.events[param.eventType][param.eventName].splice(editParam.index, 1, eventOpt)
      } else {
        tarEvent.events[param.eventType][param.eventName].push(eventOpt)
      }
    }
  }
  /**
   *初始化组件配置项改变新增事件的数据
   * @param {object} param 组件所需新增的事件的描述
   * @param {object} tarEvent 组件的所有事件的描述
   * @returns {object} 处理好的所需新增的事件的数据
   */
  addComponentOption(param, tarEvent) {
    //初始化通用配置
    const res = { ...this.initPublicOpt(param, tarEvent), ids: param.responseRectIds }
    if (param?.eventVariables?.length) {
      //初始胡事件变量
      res.eventVariables = param.eventVariables
    }
    res.update = param.update
    //update中是否使用了变量
    if (res?.update?.useVariable?.length) {
      //初始化变量标记对象
      if (!res.variableTag) {
        res.variableTag = {}
      }
      res.update.useVariable.forEach(variable => {
        variable.variableName.forEach(name => {
          //变量标记对象中需要含有每个变量的变量路径和变量来源
          let variable = tarEvent.componentVariables.find(it => it.variableName === name)
          let from = "component"
          if (!variable) {
            variable = res.eventVariables.find(it => it.variableName === name)
            from = "arguments"
          }
          //如果有，说明当前事件用到了变量监听，就做对象合并
          if (res.variableTag[name]) {
            Object.assign(res.variableTag[name], { path: variable.variablePath, from })
          } else {
            res.variableTag[name] = {
              path: variable.variablePath,
              from
            }
          }
        })
      })
    }
    return res
  }
  /**
   * 用于初始化屏幕事件(页面打开、页面滚动)的公共数据
   * @param {object} res 当前的新增事件对象的引用 用于二次处理
   * @param {*} param 组件所需新增的事件的描述
   */
  initPublicWindowOpt(res, param) {
    res.useVariable = param.useVariable
    param.useVariable.forEach(variable => {
      if (!res.variableTag) {
        res.variableTag = {}
      }
      //如果有，说明当前事件用到了变量监听，就做对象合并
      if (res.variableTag[variable.variableName]) {
        Object.assign(res.variableTag[variable.variableName], { from: variable.from, path: variable.variablePath })
      } else {
        res.variableTag[variable.variableName] = { from: variable.from, path: variable.variablePath }
      }
    })
  }
  /**
   *初始化组件显示隐藏新增事件的数据
   * @param {object} param 组件所需新增的事件的描述
   * @param {object} tarEvent 组件的所有事件的描述
   * @returns {object} 处理好的所需新增的事件的数据
   */
  addComponentShow(param, tarEvent) {
    const { action, actionDes, changeTo, duration, repeat, ids } = param
    return Object.assign(
      { ...this.initPublicOpt(param, tarEvent) },
      { action, actionDes, changeTo, duration, repeat, ids }
    )
  }
  /**
   *初始化窗口打开新增事件的数据
   * @param {object} param 组件所需新增的事件的描述
   * @param {object} tarEvent 组件的所有事件的描述
   * @returns {object} 处理好的所需新增的事件的数据
   */
  addWindow(param, tarEvent) {
    const res = { ...this.initPublicOpt(param, tarEvent), url: param.url }
    this.initPublicWindowOpt(res, param)
    return res
  }
  /**
   *初始化屏幕滚动新增事件的数据
   * @param {object} param 组件所需新增的事件的描述
   * @param {object} tarEvent 组件的所有事件的描述
   * @returns {object} 处理好的所需新增的事件的数据
   */
  addScroll(param, tarEvent) {
    const res = { ...this.initPublicOpt(param, tarEvent), position: param.position }
    this.initPublicWindowOpt(res, param)
    return res
  }
  /**
   * 初始化新增事件的公共数据
   * @param {object} param 组件所需新增的事件的描述
   * @param {object} tarEvent 组件的所有事件的描述
   * @returns {object} 处理好的所需新增的事件的数据
   */
  initPublicOpt(param, tarEvent) {
    const res = {
      eventMovement: param.eventMovement,
      movementType: param.movementType,
      from: tarEvent.publishComponentIds,
      groupId: "默认",
      id: uuid.v1(),
      lifeCycle: param.lifeCycle || new EventLifeCycle()
    }
    if (param.eventType === "dataEvents" && param.eventName === "appointDataChange") {
      res.variableTag = { ...param.variableTag }
    }
    return res
  }
  /**
   *
   * @param {object} ids 组件的ids
   * @returns 找在event中指定id的目标对象,返回该对象和对象键名
   */
  findTar(ids) {
    const idsStr = this.getIdsByStrId(ids)
    return { tar: this.allEvents() && this.allEvents()[idsStr], idsStr }
  }
  /**
   *
   * @param {sting} mode 环境名,有大屏,pc,移动端
   * @returns 返回当前页面的全部事件数据
   */
  allEvents(mode) {
    return this.eventBus[mode || this.env()]
  }
  /**
   *
   * @returns 返回当前页面的全部组件上下文(组件中的this)
   */
  allContexts() {
    return this.contexts[this.env()]
  }
  /**
   *
   * @param {object} ids 需要转化为字符串的ids
   * @returns {string} 返回一个字符串,该字符串由参数ids拼接而成
   */
  getIdsByStrId(ids) {
    if (typeof ids !== "object") return
    let path = null
    if (ids.hasOwnProperty("path")) path = ids.path
    //轮播组件没有给单页绑定的事件 统一为轮播事件或者轮播组件内的事件
    let ids2 = { ...ids }
    const pageId = ids2.pageId
    if (
      Object.keys(ids2).length === 3 &&
      ids2.hasOwnProperty("container_id") &&
      ids2.hasOwnProperty("rect_id") &&
      ids2.hasOwnProperty("swiperContent_id")
    ) {
      delete ids2.swiperContent_id
    }
    ids2.pageId = pageId
    //额外兼容处理完毕
    ids2 = this.idsFilter(ids2)
    if (path !== null) ids2.path = path
    if (ids2.hasOwnProperty("containerId")) {
      ids2.container_id = ids2.containerId
      delete ids2.containerId
    }
    if (ids2.hasOwnProperty("rectId")) {
      ids2.rect_id = ids2.rectId
      delete ids2.rectId
    }
    let name = `container_id_${ids2.container_id}`
    if (ids2.hasOwnProperty("pageId") && typeof ids2.pageId === "string") {
      //大屏专用处理
      name = `pageId_${ids2.pageId}-${name}`
    }
    if (ids2.hasOwnProperty("rect_id")) {
      name += `-rect_id_${ids2.rect_id}`
    }
    if(ids2.hasOwnProperty("cellId")){
      name+=`-cell_id_${ids2.cellId}`
      if(ids.hasOwnProperty("elementInDataGridId")){
        name+=`-elementInDataGridId_${ids2.elementInDataGridId}`
      }
    } else if (ids2.hasOwnProperty("uid") && !ids2.hasOwnProperty("elementInLayoutId")) {
      name += "-uid_" + ids2.uid
    } else if (ids2.hasOwnProperty("uid") && ids2.hasOwnProperty("elementInLayoutId") && !ids2.hasOwnProperty("elementInAutoLayoutId")) {
      name += `-uid_${ids2.uid}-elementInLayoutId_${ids2.elementInLayoutId}`
    } else if (ids2.hasOwnProperty("uid") && ids2.hasOwnProperty("elementInLayoutId") && ids2.hasOwnProperty("elementInAutoLayoutId")) {
      name += `-uid_${ids2.uid}-elementInLayoutId_${ids2.elementInLayoutId}`
      name += `-elementInAutoLayoutId_${ids.elementInAutoLayoutId}` + `-path_undefined`
    } else if (ids2.hasOwnProperty("swiperContent_id") && !ids2.hasOwnProperty("elementInSwiperId")) {
      name += `-swiperContent_id_${ids2.swiperContent_id}`
    } else if (ids2.hasOwnProperty("swiperContent_id") && ids2.hasOwnProperty("elementInSwiperId")) {
      name += `-swiperContent_id_${ids2.swiperContent_id}-elementInSwiperId_${ids2.elementInSwiperId}`
    } else if (ids2.hasOwnProperty("directionIndex") && ids2.hasOwnProperty("elementInLayoutId")) {
      // 边栏里面的组件
      name += `-directionIndex_${ids.directionIndex}` + `-elementInLayoutId_${ids.elementInLayoutId}`
    } else if(ids2.hasOwnProperty("elementInAutoLayoutId")){
      // 自动布局里的组件
      if(ids2.hasOwnProperty("path")){
        name += `-elementInAutoLayoutId_${ids.elementInAutoLayoutId}` + `-path_${ids.path ? ids.path.join('') : ids.path}`
      }else{
        name += `-elementInAutoLayoutId_${ids.elementInAutoLayoutId}` + `-path_undefined`
      }
    }

    return name
  }
  /**
   *
   * @param {object} ids
   * @returns {object} 返回一个被过滤处理过的ids,过滤掉了无效值
   */
  idsFilter(ids) {
    Object.keys(ids).forEach(k => {
      //清除null,undefined, NaN
      if (ids[k] === null || ids[k] === undefined || (typeof ids[k] === "number" && isNaN(ids[k]))) {
        delete ids[k]
      }
    })
    return ids
  }
  /**
   *根据传输入数据,找到指定的事件描述对象
   * @param {object} param 当前事件的描述
   * @returns {object} 根据传入的参数,找到的目标事件数据
   */
  getTarEvent(param) {
    //找到是否注册过事件了
    let { tar, idsStr } = this.findTar({ ...param.publishComponentIds })
    let status = false
    if (!tar) {
      tar = {
        publishComponentIds: param.publishComponentIds,
        type: param.type,
        events: new BaseEvents(),
        componentVariables: []
      }
      this.allEvents()[idsStr] = tar
      status = true
    }
    //非新增情况下才需要检查派发事件组件的变量是否被删除
    this.checkVariableChange(tar, param, status)

    //更新组件的变量数据
    return tar
  }
  /**
   * 后续新增的事件可能出现删除了原有事件变量的情况,这时候就要找出被删除的事件变量,将依赖于该事件变量的事件也同步删除
   * @param {object} tar 当前组件的事件总体数据
   * @param {object} param 当前事件的参数
   * @param {boolean} status 布尔值,用于判定该组件是否是第一次增加事件
   */
  checkVariableChange(tar, param, status) {
    //该事件如果是新增的就不用检查变量
    if (!status) {
      //进行前后变量的对比 找出是否有变量被删除了
      const dropVariables = tar.componentVariables.filter(it => {
        return (
          param.componentVariables.find(it2 => {
            return it2.variableName === it.variableName
          }) === undefined
        )
      })
      //有变量被删除 开始查找当前组件的响应事件中是否有任何地方用到了该变量
      //需要查找的地方有：
      //1：监听指定变量的事件
      //2. 使用了变量的组件事件
      //3. 使用了变量的window事件
      if (dropVariables.length) {
        this.checkVariable(tar, param, dropVariables)
      }
    }

    //最后进行组件变量更新
    tar.componentVariables = param.componentVariables.map(it => ({ ...it }))
  }
  /**
   * 在鼠标事件和数据事件中分别寻找依赖于该组件变量的事件 找到后进行删除
   * @param {object} tar 当前组件的全部事件数据
   * @param {object} param 当前组件的当前事件参数
   * @param {array} dropVariables 被删除的变量
   */
  checkVariable(tar, param, dropVariables) {
    //检查组件变量 如果在 变量变化时触发的事件 中依赖的变量没了 那么该事件也应该移出
    //1. 处理mouseEvents
    const { mouseEventsTypes, dataEventsTypes } = allEventTypes
    for (let i = 0, len = mouseEventsTypes.length; i < len; i++) {
      const eventName = mouseEventsTypes[i].value //当前事件名称 例如mouseover
      const tarEvent = tar.events.mouseEvents[eventName] //当前事件对应的数组
      if (tarEvent.length) {
        for (let j = 0, len2 = tarEvent.length; j < len2; j++) {
          if (
            dropVariables.some(it => {
              if (!tarEvent[j].variableTag) {
                return false
              } else {
                return tarEvent[j].variableTag[it.variableName]
              }
            })
          ) {
            tarEvent.splice(j, 1)
            len2--
            j--
          }
        }
      }
    }
    //2. 处理数据事件
    for (let i = 0, len = dataEventsTypes.length; i < len; i++) {
      const eventName = dataEventsTypes[i].value //当前事件名称 例如mouseover
      const tarEvent = tar.events.dataEvents[eventName] //当前事件对应的数组
      if (tarEvent.length) {
        for (let j = 0, len2 = tarEvent.length; j < len2; j++) {
          if (
            dropVariables.some(it => {
              if (tarEvent[j].url) {
                //window事件中只有url能使用变量
                return tarEvent[j].url.includes(`{${it.variableName}}`)
              } else if (tarEvent[j].variableTag) {
                //组件配置项事件通过variableTag来收集内部使用的变量
                return tarEvent[j].variableTag[it.variableName]
              } else return false
            })
          ) {
            tarEvent.splice(j, 1)
            len2--
            j--
          }
        }
      }
    }
  }
  /**
   *
   * @param {object} ids
   * @returns 根据ids返回当前事件总线中存储的指定组件的this
   */
  getContext(ids) {
    const idsStr = this.getIdsByStrId(ids)
    return this.allContexts()[idsStr]
  }
  /**
   *同步触发事件响应
   * @param {object} currEventDes  当前所需触发的事件描述
   * @param {event} mouseEvent 鼠标事件addeventlistener回调函数的参数"e"
   */
  async trigger(currEventDes, mouseEvent) {
    const { lifeCycle, from, ids: to } = currEventDes
    const { beforeTrigger, afterTrigger } = lifeCycle
    this.fromContext = this.getContext({ ...from })
    this.toContext = this.getContext({ ...to })
    if (beforeTrigger.length || afterTrigger.length) {
      try {
        await this.asyncTrigger(currEventDes, mouseEvent, beforeTrigger, afterTrigger)
      } catch (error) {
        console.log(error)
      }
    } else {
      try {
        this.normalTrigger(currEventDes, mouseEvent)
      } catch (error) {
        console.log(error)
      }
    }
  }
  /**
   *异步触发事件,会先执行事件触发前生命周期,再触发事件,再执行事件触发后生命周期
   *单个生命周期执行时,会一次执行生命周期任务队列中的每一个任务,并且会进行异步等待
   * @param {object} currEventDes  当前所需触发的事件描述
   * @param {event} mouseEvent 鼠标事件addeventlistener回调函数的参数"e"
   * @param {Array} beforeTrigger 当前所需触发事件的事前触发前生命周期行为数组
   * @param {Array} afterTrigger 当前所需触发事件的事前触发后生命周期行为数组
   */
  async asyncTrigger(currEventDes, mouseEvent, beforeTrigger, afterTrigger) {
    if (beforeTrigger.length) {
      for (let i = 0; i < beforeTrigger.length; i++) {
        try {
          await this.lifeCycleExec(beforeTrigger[i], currEventDes)
        } catch (error) {
          console.log(error)
        }
      }
    }
    try {
      this.normalTrigger(currEventDes, mouseEvent)
    } catch (error) {
      console.log(error)
    }
    if (afterTrigger.length) {
      for (let i = 0; i < afterTrigger.length; i++) {
        try {
          await this.lifeCycleExec(afterTrigger[i], currEventDes)
        } catch (error) {
          console.log(error)
        }
      }
    }
  }
  /**
   *生命周期执行函数,执行单个生命周期
   * @param {*} lifeCycleEvent 生命周期数组中的单个执行描述
   * @param {*} currEventDes 当前事件的事件描述
   * @returns
   */
  async lifeCycleExec(lifeCycleEvent, currEventDes) {
    return new Promise((resolve, reject) => {
      const { type, time, pluginName } = lifeCycleEvent
      /* 即时更新指定的this,避免加了延迟后的this未更新 */
      const { from, ids: to } = currEventDes
      this.fromContext = this.getContext({ ...from })
      this.toContext = this.getContext({ ...to })
      if(!this.toContext && to && to.hasOwnProperty("uid") && to.hasOwnProperty("elementInLayoutId")){
        let idsCopy1 = JSON.parse(JSON.stringify(to))
        delete idsCopy1.pageId
        this.toContext = this.getContext({ ...idsCopy1 })
      }
      switch (type) {
        //更新触发事件的组件的后台数据,更新原理为,在事件触发前,会临时存储触发组件和响应组件的this,通过该this触发组件内部的updateData
        case "fromFetch":
          this.fromContext.updateData().then(res => resolve(1))
          break
        case "toFetch":
          //更新触发事件的组件的后台数据,更新原理为,在事件触发前,会临时存储触发组件和响应组件的this,通过该this触发组件内部的updateData
            if(this.toContext?.options?.innerElement === "cxSelect"){
              //下拉框接收参数需要清空分页值
              this.toContext.updateData(true).then(res => resolve(1))
            }else{
              this.toContext.updateData().then(res => resolve(1))
            }
          break
        //暂停动作,该动作可以在单个事件生命周期数组依次执行时,进行暂停等待,等待结束后继续执行后续的动作
        case "delay":
          setTimeout(() => {
            resolve(1)
          }, time * 1000)
          break
        //执行事件插件,分为本地插件和热重载插件,热重载插件的名字为'fetch-'开头,此时会从后台中获取插件json并且执行,详见$initPlugin的执行原理
        case "plugin":
          if (typeof pluginName === "string" && pluginName.trim().length > 0) {
            //执行预设的事件插件
            if (eventPlugins[pluginName]) {
              eventPlugins[pluginName](this.fromContext, this.toContext, currEventDes, this.eventBus).then(res => resolve(1))
            } else if (pluginName.indexOf("fetch-") === 0) {
              //执行后台存储的事件插件
              execPlugins([pluginName], [this.fromContext, this.toContext, currEventDes])
            } else resolve(1)
          } else resolve(1)
          break
        default:
          break
      }
    })
  }
  /**
   *处理事件响应动作
   * @param {object} currEventDes 当前事件动作的描述
   * @param {mouseEvent|null} mouseEvent 如果是鼠标事件,则该形参为:a.addEventListener('click',(ev)=>{})中的ev,非鼠标事件则为null
   */
  normalTrigger(currEventDes, mouseEvent) {
    const { eventMovement, movementType } = currEventDes
    if (eventMovement === "component" && movementType === "options") {
      this.handleComponentOptionsEv(currEventDes, mouseEvent)
    }
    if (eventMovement === "component" && movementType === "show") {
      this.handleComponentShowEv(currEventDes, mouseEvent)
    }
    if (eventMovement === "window" && (movementType === "open" || movementType === "self")) {
      this.handleWindowEv(currEventDes, mouseEvent)
    }
    if (eventMovement === "window" && (movementType === "scroll" || movementType === "scrollBy")) {
      this.handleScrollEv(currEventDes, mouseEvent)
    }
  }
  /**
   * 处理单个组件样式调整事件动作
   * @param {object} eventDes 当前事件动作的描述
   * @param {*} mouseEvent 鼠标事件监听回调函数中的event
   */
  handleComponentOptionsEv(eventDes, mouseEvent) {
    const { ids, update, eventVariables, from, variableTag } = eventDes
    const responseElArr = this.getResponseEl(ids)
    //设置过渡动画和时间
    if (update.transitionTime) {
      responseElArr.forEach(el => (el.style.transition = `all ${update.transitionTime}s ease 0s`))
    }
    const completeParam = {
      ...ids
    }
    //修改单个具体配置项,具体数据结构见eventBus_mock
    if (update.type === "diff") {
      if(this.toContext && this.toContext.options?.eventClearOption){
        update.option = []
      }
      update.option.forEach(diff => {
        completeParam.option_name = diff.path
        completeParam.option_val = diff.value
        this.changeOption(completeParam)
      })
    } else {
      //全量的修改整个options,谨慎使用,会对整个options整个替换
      this.fromContext.$store.dispatch(this.fromContext.request_prefix + "/changeAllOptions", {
        ...ids,
        options: JSON.parse(JSON.stringify(update.option))
      })
    }
    //有使用变量 就需要再次根据变量描述更新响应组件的配置项
    if (update?.useVariable?.length) {
      //循环更新变量中的值
      const normalVariable = []
      const eventQueryVariable = []
      //将普通变量使用场景和组件接口传参使用场景分开
      for (let i = 0; i < update.useVariable.length; i++) {
        if (update.useVariable[i].variablePath === "eventQuery") {
          eventQueryVariable.push(update.useVariable[i])
        } else normalVariable.push(update.useVariable[i])
      }
      for (let i = 0; i < normalVariable.length; i++) {
        const variable = normalVariable[i]
        const { variableName, variablePath, matchValue } = variable
        const changeValue = this.handleVariableInComponentStr(
          variableName,
          eventVariables,
          from,
          matchValue,
          variableTag,
          mouseEvent
        )
        if (changeValue === undefined) continue
        completeParam.option_name = variablePath
        completeParam.option_val = changeValue
        this.changeOption(completeParam)
      }
      let eventQuery = ""
      for (let i = 0; i < eventQueryVariable.length; i++) {
        const variable = eventQueryVariable[i]
        const { variableName, variablePath, matchValue } = variable
        const changeValue = this.handleVariableInComponentStr(
          variableName,
          eventVariables,
          from,
          matchValue,
          variableTag,
          mouseEvent
        )
        if (changeValue === undefined) continue
        eventQuery += changeValue
      }
      // 解决下拉框清空参数传递参数为空的需求
      if (eventQuery.length || this.fromContext.options.innerElement === "cxSelect") {
        completeParam.option_name = "eventQuery"
        completeParam.option_val = eventQuery
        this.changeOption(completeParam)
      }
    }
    //修改完成 还原过渡动画
    if (update.transitionTime) {
      setTimeout(() => {
        responseElArr.forEach(el => (el.style.transition = "0s"))
      }, update.transitionTime * 1000)
    }
  }
  changeOption(param) {
    if (param.uid != null) {
      this.fromContext.$store.dispatch(this.fromContext.request_prefix + "/changeLayoutOption", param)
    } else if (typeof param.elementInSwiperId !== "undefined" && param.elementInSwiperId !== null) {
      this.fromContext.$store.dispatch(this.fromContext.request_prefix + "/changeSwiperOptions", param)
    } else {
      this.fromContext.$store.dispatch(this.fromContext.request_prefix + "/changeOptions", param)
    }
  }
  /**
   * 获取相应组件的dom 有可能会获取到多个 这是组件在克隆操作中导致的
   * @param {object} ids
   * @returns {Array.<HTMLElement>}
   */
  getResponseEl(ids) {
    const componentId = { ...ids }
    delete componentId.pageId
    const name = this.getIdsByStrId(componentId)
    return Array.from(document.getElementsByClassName(name))
  }
  /**
   * 处理组件显示隐藏事件,主要使用animate.css实现的
   * @param {object} ev 当前事件动作的描述
   */
  handleComponentShowEv(ev) {
    const { ids, changeTo, action, duration, repeat, actionDes } = ev
    const idsStr = this.getIdsByStrId({ ...ids })
    let rootEl = document.getElementsByClassName(idsStr)[0]
    if(!rootEl && ids.uid && ids.hasOwnProperty("elementInLayoutId")){
      //   显隐的响应组件在自由布局内部时不起作用
      //  自由布局内部组件的类名未带 pageId_{pageId}, 需要删除
      let idsCopy1 = JSON.parse(JSON.stringify(ids))
      delete idsCopy1.pageId;
      let idsStrCopy1 = this.getIdsByStrId({ ...idsCopy1 })
      rootEl = document.getElementsByClassName(idsStrCopy1)[0]
    }
    const el = rootEl.getElementsByClassName("rect")[0]
    let elClassList = el.classList || []
    if(elClassList.value.indexOf('img-container') !== -1){
      let el1 = el.getElementsByClassName("img-box")[0]
      elClassList = el1.classList || []
    } else if(elClassList.value.indexOf('d-roll-box') !== -1){
      let el1 = el.getElementsByClassName("d-roll-box-style")[0]
      elClassList = el1.classList || []
    }
    let animateType = changeTo
    //显隐切换
    if (changeTo === "exchange") {
      const name = Array.from(elClassList).find(
        it => it.includes("animate") && (it.includes("In") || it.includes("Out"))
      )
      if (name) {
        if (name.includes("In")) animateType = "Out"
        else if (name.includes("Out")) animateType = "In"
      } else {
        animateType = "Out"
      }
    }
    for (let i = 0; i < elClassList.length; i++) {
      if (elClassList[i].includes("animate")) elClassList.remove(elClassList[i--])
    }
    //动画类型class拼接
    const animateClass = "animate__" + action + animateType + actionDes
    //动画持续时间设置
    rootEl.style.setProperty("--animate-duration", duration + "s")
    // 动画重复次数设置
    const repeatClass = repeat === "0" ? "" : repeat === "infinite" ? "animate__" + repeat : "animate__repeat-" + repeat
    //将执行动画的animate__animated,和动画动作添加到dom中
    elClassList.add("animate__animated", animateClass)
    //将动画重复次数添加到dom中
    repeatClass.length && elClassList.add(repeatClass)
  }
  /**
   * 处理页面打开动作
   * @param {object} ev 当前事件动作的描述
   * @param {event} e
   */
  handleWindowEv(ev, e) {
    const { from, useVariable } = ev
    //有些值中使用了组件变量,这时需要把组件变量替换为具体值,再返回一个处理后的值
    const fixUrl = this.handleVariableInWindowExec(ev.url, useVariable, from, e)
    //在当前页面打开
    if (ev.movementType === "self") {
      window.open(fixUrl, "_self")
      //等待五秒,如果新开页面的host地址和老页面一致,则需要手动relad触发页面重载
      setTimeout(() => {
        if (fixUrl.includes(window.location.host)) window.location.reload()
      }, 500)
    } else {
      //在新页面打开
      window.open(fixUrl)
    }
  }
  /**
   * 处理页面打滚动动作
   * @param {object} ev 当前事件动作的描述
   * @param {event} e
   */
  handleScrollEv(ev, e) {
    //scroll scrollBy
    const { from, useVariable } = ev
    //有些值中使用了组件变量,这时需要把组件变量替换为具体值,再返回一个处理后的值
    const x = this.handleVariableInWindowExec(ev.position[0], useVariable, from, e)
    const y = this.handleVariableInWindowExec(ev.position[1], useVariable, from, e)
    window[ev.movementType](Number(x), Number(y))
  }
  /**
   *
   * @returns {string} 当前环境(大屏,pc,移动端)返回具体的环境名
   */
  env() {
    const path = router.history.current.path.slice(1)
    switch (path) {
      case "home":
      case "homeMoudles":
        return "stage"
      case "appHome":
        return "appStage"
      case "bigScreen":
        return "stage"
      case "bigScreenPreview":
        return "stage"
    }
    if (path.includes("v2/p") || window.isBigScreenPreviewUrl) {
      return "stage"
    }
  }
  //事件合并操作,对于从系统样式中添加到画布中的组件,对该组件保存的样式合并到当前的事件总线中
  mergeEvent(options, type) {
    // const { event, layoutUidMap } = options
    // if (options.event && typeof options.event === "object") {
    Object.assign(this.allEvents(), this.copyByType(options, type))
    // delete options.event
    // delete options.layoutUidMap
    // }
  }
  //在移动端自适应时,把pc端的事件克隆一份到移动端
  initAppStageEvent() {
    let allEvents = this.allEvents("stage")
    if (allEvents) {
      const stageEvent = filterPcEvents(JSON.parse(JSON.stringify(allEvents)))
      this.eventBus.appStage = stageEvent
    }
  }
  /**
   * 根据组件类型 对事件进行一次克隆
   * @param {object} options 原始事件描述
   * @param {string} type 事件类型,分为组件事件和单元格内组件的事件
   * @returns {object} 返回一个针对type克隆的事件描述
   */
  copyByType(options, type) {
    let res = {}
    switch (type) {
      case "rect":
        res = copyRectEvents(options)
        break
      case "col":
        res = copyColEvents(options)
        break

      default:
        break
    }
    return res
  }
  /**
   *初始化页面中的全部事件
   * @param {object} data 需要初始化到当前事件总线中的事件
   * @param {string} type 当前环境名,对应环境的事件放到对应环境的集合中,
   */
  init(data, type) {
    this.eventBus[type] = JSON.parse(JSON.stringify(data))
    console.log("eventBus", this)
  }
  /**
   * 删除指定事件
   * @param {object} param 需要删除的事件的描述
   */
  deleteEvent(param) {
    const { publishComponentIds, eventId, eventType, eventName, toIds } = param
    let { tar, idsStr } = this.findTar({ ...publishComponentIds })
    const index = tar.events[eventType][eventName].findIndex(it => it.id === eventId)
    tar.events[eventType][eventName].splice(index, 1)
    let toContext2 = this.getContext({ ...toIds })
    if(toContext2.options.hasOwnProperty("eventImmediateTrue")){
      delete toContext2.options.eventImmediateTrue
      let param={
        ...toIds,
        option_name: "eventImmediateTrue",
        option_val: false
      }
      // 自由布局内部情况
      if(toContext2.myid && toContext2.myid.hasOwnProperty("uid") && toContext2.myid.hasOwnProperty("elementInLayoutId")){
        toContext2.$store.dispatch(toContext2.request_prefix + "/changeLayoutOption", param)
      }else{
        toContext2.$store.dispatch(toContext2.request_prefix + "/changeOptions", param)
      }
    //  删除 eventImmediateTrueIdsArr
      let arr2 = toContext2.options.eventImmediateTrueIdsArr
      if(arr2.length > 0){
        let str1 = JSON.stringify(publishComponentIds)
        let index1 = arr2.indexOf(str1)
        if(index1 > -1){
          arr2.splice(index1, 1)
          let param1={
            ...toIds,
            option_name: "eventImmediateTrueIdsArr",
            option_val: arr2
          }
          // 自由布局内部情况
          if(toContext2.myid && toContext2.myid.hasOwnProperty("uid") && toContext2.myid.hasOwnProperty("elementInLayoutId")){
            toContext2.$store.dispatch(toContext2.request_prefix + "/changeLayoutOption", param1)
          }else{
            toContext2.$store.dispatch(toContext2.request_prefix + "/changeOptions", param1)
          }
        }
      }
    }
  }
  /**
   *
   * @param {Object} ids 被删除组件的id
   * @param {String} type 被删除组件的类型 如果删除的是足有布局组件内部的组件或者是轮播组件内部的组件 就没有type
   * 删除指定组件的依赖事件，例如 页面删除一个组件时，需要删除该组件的响应事件，并删除该组件的触发事件
   */
  deleteEventByDep(ids, type) {
    Object.keys(ids).forEach(k => {
      if (ids[k] === null) {
        delete ids[k]
      }
    })
    //1.处理 删除当前组件时 同时需要删除当前组件的事件的情况
    const { tar, idsStr } = this.findTar({ ...ids })
    if (tar) {
      delete this.allEvents()[idsStr]
      delete this.allContexts()[idsStr]
    }
    // 删除自由布局组件或者轮播组件时 需要同时删除该组件内部组件的事件
    if (
      type &&
      !type.includes("del") &&
      (type.toLowerCase().includes("swiper") || type.toLowerCase().includes("layout"))
    ) {
      //删除的是自由布局组件或者轮播组件 需要删除该组件所有内部组件的事件
      const wrapperComponentStr = idsStr.split("-").slice(0, 2).join("-")
      Object.keys(this.allEvents())
        .filter(k => k.includes(wrapperComponentStr))
        .forEach(delKey => {
          delete this.allEvents()[delKey]
          delete this.allContexts()[delKey]
        })
    }
    if (type === "delColInLayout" || type === "delSwiperContent") {
      //删除自由布局内的行或者轮播组件的页 需要删除该行内的所有子组件
      const colInLayoutStr = idsStr.split("-").slice(0, 3).join("-")
      Object.keys(this.allEvents())
        .filter(k => k.includes(colInLayoutStr))
        .forEach(delKey => {
          delete this.allEvents()[delKey]
          delete this.allContexts()[delKey]
        })
    }
    //2.处理 删除当前组件时 同时删除 将当前组件作为响应组件的事件
    //分别在所有组件的鼠标事件和数据事件中寻找是否有响应事件的组件为当前删除的组件,如果有,就删除该响应事件
    const { mouseEventsTypes, dataEventsTypes } = allEventTypes
    Object.values(this.allEvents()).forEach(tarEvent => {
      const { events } = tarEvent
      mouseEventsTypes.forEach(eventType => {
        const eventName = eventType.value
        if (events.mouseEvents[eventName]) {
          for (let i = 0; i < events.mouseEvents[eventName].length; i++) {
            const mouseEvent = events.mouseEvents[eventName][i]
            const { tar: mouseEventTar, idsStr: mouseEventIdsStr } = this.findTar({ ...mouseEvent.ids })
            //如果有任一组件的事件响应组件是现在正在删除的组件 那么就需要把该事件响应给删除
            if (mouseEventIdsStr === idsStr) {
              events.mouseEvents[eventName].splice(i--, 1)
            }
          }
        }
      })
      dataEventsTypes.forEach(eventType => {
        const eventName = eventType.value
        if (events.dataEvents[eventName]) {
          for (let i = 0; i < events.dataEvents[eventName].length; i++) {
            const dataEvent = events.dataEvents[eventName][i]
            const { tar: dataEventTar, idsStr: dataEventIdsStr } = this.findTar({ ...dataEvent.ids })
            //如果有任一组件的事件响应组件是现在正在删除的组件 那么就需要把该事件响应给删除
            if (dataEventIdsStr === idsStr) {
              events.dataEvents[eventName].splice(i--, 1)
            } else if (type.toLowerCase().includes("layout")) {
              //自由布局组件作为响应组件
              let wrapperComponentStr1 = dataEventIdsStr.split("-").slice(0, 2).join("-")
              if (wrapperComponentStr1 === idsStr) {
                events.dataEvents[eventName].splice(i--, 1)
              }
            }
          }
        }
      })
    })
  }
  /**
   * 处理页面事件(页面打开,页面滚动)中,使用了组件变量的场景
   * @param {string} str 需要进行组件变量替换的字符串
   * @param {array.<object>} useVariable 使用了那些变量 变量路径
   * @param {object} from 来自哪个组件
   * @param {mouseEvent} e
   * @returns
   */
  handleVariableInWindowExec(str, useVariable, from, e) {
    if (useVariable.length) {
      const { tar, idsStr } = this.findTar(from)
      const stage = this.fromContext.$store.state[this.fromContext.request_prefix]
      const rectAttr = this.fromContext.getAttrById(stage, tar.publishComponentIds)
      const rectOptions = rectAttr.options ? rectAttr.options : rectAttr
      useVariable.forEach(variableDes => {
        const { variablePath, variableName } = variableDes
        //事件变量用e，组件变量rectOptions
        const value = this.fromContext.hasProperty(variableDes.from === "arguments" ? e : rectOptions, variablePath)
        str = str.replaceAll(`((${variableName}))`, value)
      })
    }
    if (str.length) {
      // const execStr = str.match(this.execRE)?.map(it => it.slice(2, -2))
      // if (execStr?.length) {
      //   execStr?.forEach(exec => {
      //     const res = eval(exec)
      //     str = str.replaceAll(`{{${exec}}}`, res)
      //   })
      // }
    }
    return str
  }
  /**
   * 处理事件响应时,使用了变量的具体某个配置项更新动作场景下,将变量替换到具体的某个配置项里
   * @param {Array.<string>} variableName 变量名数组
   * @param {object} eventVariables 该时间动作使用了哪些变量
   * @param {object} fromId 该事件是有哪个组件触发的,该组件的ids
   * @param {string} matchValue 需要进行替换字符串,里面包含了符合变量使用书写规范的字符串
   * @param {object} variableTag 变量标记对象,在编辑页编辑事件时会以对象的形式存储到variableTag,减少预览页搜索变量的动作提高预览页事件触发时的性能
   * @param {mouseEvent} mouseEvent
   * @returns {string|number}
   */
  handleVariableInComponentStr(variableName, eventVariables, fromId, matchValue, variableTag, mouseEvent) {
    // 从当前事件的派发组件对象中找
    //！！注意！！一定要先从派发组件中找 大概率会找到
    const variableValues = [] //用于存储 使用了那些变量,那些变量当前的值是什么
    variableName.forEach(_name => {
      const variableDes = variableTag[_name]
      if (variableDes.from === "component") {
        //来自组件的某个options属性的变量
        let fromOpt = this.fromContext.getAttrById(
          this.fromContext.$store.state[this.fromContext.request_prefix],
          fromId
        )
        fromOpt = fromOpt.options ? fromOpt.options : fromOpt
        let val = this.fromContext.hasProperty(fromOpt, variableDes.path)
        //判断是自由布局,有数据源，列点击的事件
        if(fromOpt.innerElement === "emptyLayoutComponent" && fromOpt.noCacheComponent && fromOpt.queryColValue){
          let datas = this.fromContext.shareDataPool.getData(
              `layoutData-${this.fromContext.myid.container_id}-${this.fromContext.myid.rect_id}-${this.fromContext.options.activeIndex}`
          )
          if (datas) {
            const res = JSON.parse(datas)
            let uids = this.fromContext.shareDataPool.getData(
                `layoutData-${this.fromContext.myid.container_id}-${this.fromContext.myid.rect_id}-${this.fromContext.options.activeIndex}-uids`
            )
            let uidsObject = JSON.parse(uids)
            let colIndex = uidsObject.indexOf(this.fromContext.colsOptions.uid)
            val = res[colIndex][val].value
          }
        }
        variableValues.push({
          variableName: _name,
          variableValue: isNaN(val) ? val : val
        })
      } else {
        //来自mouseEvent参数的变量
        const val = this.fromContext.hasProperty(mouseEvent, variableDes.path)
        variableValues.push({
          variableName: _name,
          variableValue: isNaN(val) ? val : val
        })
      }
    })
    let changeValue = matchValue
    //遍历需要使用的变量,对当前的被修改值进行字符串替换
    variableValues.forEach(variableValueDes => {
      changeValue = changeValue.replaceAll(`((${variableValueDes.variableName}))`, variableValueDes.variableValue)
    })
    //正则匹配含有模板字符串的写法
    // const matchArr = changeValue.match(this.execRE)?.map(it => it.slice(2, -2))
    // //处理js字符串
    // matchArr?.forEach(exec => {
    //   const res = eval(exec)
    //   changeValue = changeValue.replaceAll(`{{${exec}}}`, res)
    // })

    //如果是个数字字符串 那就需要变成一个数字 不然组件使用该参数时可能会出错
    /*if (!isNaN(changeValue)) {
      changeValue = Number(changeValue)
    }*/
    return changeValue
  }
  /**
   * 删除所有事件
   */
  clearAllEvents() {
    this.eventBus[this.env()] = {}
  }
  /**
   * 用于大屏预览页的场景下,给当前事件总线中的所有大屏事件的属性名都加上pageId_
   * 例如 某个事件在事件总线中的名字为container_id_1-rect_id-1,该事件在pageId为asd23qqq的页面下
   * 这个时候在大屏预览页下,该事件在事件总线中的属性名应该为pageId_asd23qqq-container_id_1-rect_id-1
   * @param {object} event 需要进行大屏预览页适配的事件总线数据
   * @param {string} pageId
   * @returns
   */
  createPageId(event = {}, pageId) {
    //大屏预览页专用处理
    const res = {}
    Object.keys(event).forEach(originId => {
      const newId = `pageId_${pageId}-${originId}`
      const events = event[originId].events
      res[newId] = event[originId]
      Object.keys(events).forEach(eventType => {
        const event = events[eventType]
        Object.keys(event).forEach(eventName => {
          if (event[eventName].length) {
            event[eventName].forEach(eventDetail => {
              if (eventDetail.from) {
                eventDetail.from.pageId = pageId
              }
              if (eventDetail.ids) {
                eventDetail.ids.pageId = pageId
              }
            })
          }
        })
      })
    })
    return res
  }
  /**
   * 修改事件总线中某个事件的某个属性
   * @param {object} param 需要修改的属性的参数
   * @param {string} param.name 需要修改的参数名
   * @param {any} param.value 需要修改的属性值
   * @param {object} param.event 需要修改的事件描述
   * @param {sting} param.name 事件名
   * @param {string} param.type 事件类型
   * @returns
   */
  changeEventAttr(param) {
    return new Promise((resolve, reject) => {
      const { name, value, event, eventName, eventType } = param
      const { from, ids } = event
      let { tar, idsStr } = this.findTar({ ...from })
      const tarEvent = tar.events[eventType][eventName].find(it => it.id === event.id)
      this.toContext1 = this.getContext({ ...ids })
      if (name.includes(".")) {
        const names = name.split(".")
        const lastName = names.pop()
        if(lastName === "beforeTrigger" && this.toContext1 ){
          value.forEach(item1=>{
            if(item1.type==="plugin" && item1.pluginName.indexOf("immediateTrue") > -1) {
              let param={
                ...ids,
                option_name: "eventImmediateTrue",
                option_val: true
              }
              // 自由布局内部情况
              if(this.toContext1.myid && this.toContext1.myid.hasOwnProperty("uid") && this.toContext1.myid.hasOwnProperty("elementInLayoutId")){
                this.toContext1.$store.dispatch(this.toContext1.request_prefix + "/changeLayoutOption", param)
              }else{
                this.toContext1.$store.dispatch(this.toContext1.request_prefix + "/changeOptions", param)
              }
              // 添加触发组件id
              let valueFromIds = [], fromStr = JSON.stringify(from)
              if(this.toContext1.options.hasOwnProperty("eventImmediateTrueIdsArr")){
                valueFromIds = this.toContext1.options.eventImmediateTrueIdsArr
                if(!valueFromIds.includes(fromStr)){
                  valueFromIds.push(fromStr)
                }
              }else{
                valueFromIds.push(fromStr)
              }
              let param1={
                ...ids,
                option_name: "eventImmediateTrueIdsArr",
                option_val: valueFromIds
              }
              // 自由布局内部情况
              if(this.toContext1.myid && this.toContext1.myid.hasOwnProperty("uid") && this.toContext1.myid.hasOwnProperty("elementInLayoutId")){
                this.toContext1.$store.dispatch(this.toContext1.request_prefix + "/changeLayoutOption", param1)
              }else{
                this.toContext1.$store.dispatch(this.toContext1.request_prefix + "/changeOptions", param1)
              }
            }
          })
        }
        let temp = tarEvent
        const type = names.some(_name => {
          if (temp.hasOwnProperty(_name)) {
            temp = temp[_name]
          } else return true
        })
        if (type) {
          reject("路径不正确")
        } else {
          temp[lastName] = value
          resolve("修改成功")
        }
      } else {
        tarEvent[name] = value
        resolve("修改成功")
      }
    })
  }
  //插入事件 用于在交互列表页,拖拽交换时间顺序时的插入事件动作
  insertEvent(param) {
    const { publishComponentIds, event, eventType, eventName, nextEvent } = param
    let { tar, idsStr } = this.findTar({ ...publishComponentIds })
    if (typeof nextEvent !== "object") {
      //说明是拖拽的最有一个 直接末尾插入
      tar.events[eventType][eventName].push(event)
    } else {
      const index = tar.events[eventType][eventName].findIndex(it => it.id === nextEvent.event.id)
      tar.events[eventType][eventName].splice(index, 0, event)
    }
  }

  //检测字符串是否闭合，变量是否存在
  /**
   *
   * @param {String} str //需要检测变量的字符串
   * @param {Object} variables 变量对象，包含组件配置项变量和事件参数变量
   * @returns
   */
  checkMatchStr(str, variables) {
    return new Promise((resolve, reject) => {
      const { componentVariables, eventVariables } = variables
      const errMsg = (msg, value) => {
        return { msg, value }
      }
      if (checkStr(str)) {
        const variableInStr = str.match(this.variableRE)?.map(it => it.slice(2, -2))
        if (!variableInStr) {
          //没有变量 直接返回
          resolve({ variables: [] })
        } else {
          const res = []
          for (let i = 0; i < variableInStr.length; i++) {
            const variable = variableInStr[i]
            const componentIndex = componentVariables?.findIndex(item => item.variableName === variable)
            let eventIndex = -1
            if (componentIndex === -1 && eventVariables) {
              eventIndex = eventVariables?.findIndex(item => item.variableName === variable)
            }
            if (componentIndex === -1 && eventIndex === -1) {
              reject(errMsg(`变量((${variable}))不存在`, variable))
              break
            } else {
              if (componentIndex !== -1) {
                //组件options变量
                res.push({
                  variablePath: componentVariables[componentIndex].variablePath,
                  variableName: variable,
                  from: "component"
                })
              } else {
                res.push({
                  variablePath: eventVariables[eventIndex].variablePath,
                  variableName: variable,
                  from: "arguments"
                })
              }
            }
          }
          resolve({ variables: res })
        }
      } else {
        reject(errMsg("大括号未正确闭合"))
      }
    })
  }
}

export class EventLifeCycle {
  constructor() {
    this.beforeTrigger = []
    this.afterTrigger = []
  }
}
class BaseEvents {
  constructor() {
    this.mouseEvents = {}
    this.dataEvents = {
      anyDataChange: [],
      appointDataChange: []
    }
    this.initMouseEvents()
  }
  initMouseEvents() {
    allEventTypes.mouseEventsTypes.forEach(item => {
      this.mouseEvents[item.value] = []
    })
  }
}
//数据长这样👇
const eventBus_mock = {
  "container_id_1-rect_id-1": {
    //组件id
    publishComponentIds: {
      container_id: 1,
      rect_id: 1
    },
    type: "normal", //组件类型 图表组件（echarts）还是普通组件（normal）
    //数据变量 所有被响应组件通用的变量 允许设置多个变量,变量可在事件响应动作是被使用
    componentVariables: [
      {
        //变量数据来自options的哪里
        variablePath: "bgColor",
        //变量名
        variableName: "var1"
      },
      {
        //变量数据来自哪里可以用点来表示需要深层获取的变量
        variablePath: "chartOption.label.labelFontColor",
        variableName: "var2"
      }
    ],
    events: {
      //事件触发条件
      //mouseEvents: 鼠标事件，鼠标进行某些操作时才会执行的事件
      //dataEvents: 数据事件，组件数据或变量发生改变时才会执行的事件
      //以上两种触发条件的可执行事件是一致的
      mouseEvents: {
        mouseOver: [
          {
            groupId: "默认", //事件的事件组id，同一个事件组事件会在一批执行，不同组的事件不受相互因为组内事件的时间延迟影响
            lifeCycle: { beforeTrigger: [], afterTrigger: [] },
            eventMovement: "window",
            id: "weqwdnasoda-dnqcvwofnweof-Fwen231ne1o312mn3oi1",
            movementType: "scroll", //调用window.scroll API
            Position: [1, 2] //如果使用了变量则会用变量名进行正则
          },
          {
            groupId: "默认",
            lifeCycle: { beforeTrigger: [], afterTrigger: [] },
            eventMovement: "window",
            id: "weqwdnasoda-dnqcvwofnweof-Fwen231ne1o312mn3oi1",
            movementType: "scrollBy", //调用window.scrollBy API
            position: [1, "{{var3}}"] //如果使用了变量则会用变量名进行正则
          },
          {
            groupId: 1,
            //来自哪里 指向当前事件是哪个组件的响应事件的那个对象
            from: {
              container_id: 1,
              rect_id: 1
            },
            id: "weqwdnasoda-dnqcvwofnweof-Fwen231ne1o312mn3oi1",
            //事件响应类型/触发事件后的动作
            //component：组件响应事件，该类型为修改被相应组件配置项的类型
            //window： 浏览器响应事件，该类型为进行浏览器操作 例如打开新页面之类的
            eventMovement: "component",
            movementType: "options", //组件事件动作类型 options为更新配置项，show为更新组件显示隐藏
            ids: {
              container_id: 1,
              rect_id: 5
            },
            lifeCycle: {
              //事件触发的生命周期
              beforeTrigger: [
                //触发前
                {
                  //延时两秒
                  movement: "delay",
                  time: 2000
                },
                {
                  //更新组件数据
                  movement: "fetch"
                }
              ],
              afterTrigger: [] //触发后
            },
            //事件参数变量 来自触发函数的函数参数 当变量名重名时， 优先级：事件参数变量 > 组件参数变量
            eventVariables: [
              {
                variablePath: "target.offsetWidth",
                variableName: "var3"
              }
            ],
            //变量标签，用于标识该事件使用了那些变量,包含组件变量和参数变量，
            //用于便于在组件变量发生改变时删除事件
            variableTag: {
              var1: {
                path: "width",
                from: "component"
              },
              var2: {
                path: "height",
                from: "component"
              },
              var3: {
                path: "target.offsetWidth",
                from: "arguments"
              }
            },
            update: {
              //更新方式，如果为diff，则是改了哪些更新那些，如果为force，则是全量替换,如果为show，则为显示隐藏设置
              type: "diff",
              transitionTime: 1, //过渡动画时长
              option: [
                {
                  path: "width",
                  value: 100
                }
              ],

              //是否使用变量,允许使用多个变量
              useVariable: [
                {
                  variableName: ["var1"], //变量名
                  variablePath: "fontSize", //具体替换的数据在options中的位置
                  matchValue: "{{var1}}"
                },
                {
                  variableName: ["var2", "var3"], //变量名
                  variablePath: "chartOption.label.fontSize", //具体替换的数据在options中的位置
                  matchValue: "这个数字：{{{{{var2}}*Math.random()*3+{{var3}}}}}是来自参数中的" //将大括号及大括号内的内容替换为变量值
                },
                {
                  variableName: ["var2"], //变量名
                  variablePath: "chartOption.label.fontColor", //具体替换的数据在options中的位置
                  matchValue: "这个数字：{{var2}}是来自参数中的" //将大括号及大括号内的内容替换为变量值
                }
              ]
            }
          },
          {
            groupId: 1,
            lifeCycle: { beforeTrigger: [], afterTrigger: [] },
            eventMovement: "window",
            from: {
              container_id: 1,
              rect_id: 1
            },
            id: "weqwdnasoda-dnqcvwofnweof-Fwen231ne1o312mn3oi1",
            movementType: "self", //组件浏览器动作类型 open为打开新窗口 self为在当前窗口打开
            url: "www.baidu.com/{{var1}}",
            useVariable: [{ variablePath: "width", variableName: "var1", from: "component" }],
            variableTag: {
              var1: { path: "width", from: "component" }
            }
          }
        ]
      },
      dataEvents: {
        //任一数据发生改变时执行
        anyDataChange: [
          {
            groupId: 2,
            lifeCycle: { beforeTrigger: [], afterTrigger: [] },
            eventMovement: "window",
            movementType: "open",
            from: {
              container_id: 1,
              rect_id: 1
            },
            id: "weqwdnasoda-dnqcvwofnweof-Fwen231ne1o312mn3oi1",
            url: "www.baidu.com/(())", //如果使用了变量则会用变量名进行正则 否则 直接跳转
            // useVariable和variableTag只有一个就可以，这里是为了和组件事件风格保持一致，便于变量检测时统一删除事件
            //使用了那些变量
            useVariable: [{ variablePath: "width", variableName: "var1", from: "component" }],
            // 使用了的变量标签其实对于window事件，
            variableTag: {
              var1: { path: "width", from: "component" }
            }
          }
        ],
        // 指定数据变量发生改变时执行
        appointDataChange: [
          {
            groupId: "默认",
            lifeCycle: { beforeTrigger: [], afterTrigger: [] },
            variableTag: {
              //需要监听发布事件的那个组件的数据变化的数据名
              var1: {
                path: "linkUrl",
                form: "arguments"
              }
            },
            id: "weqwdnasoda-dnqcvwofnweof-Fwen231ne1o312mn3oi1",
            eventMovement: "component",
            movementType: "show",
            from: {
              container_id: 1,
              rect_id: 1
            },
            ids: {
              container_id: 1,
              rect_id: 5
            },
            update: {
              show: true, //显示隐藏响应事件，该配置支持接收参数为：true:显示，false:隐藏，auto：显示隐藏切换
              action: "fade-in",
              speed: "fast"
            }
          }
        ]
      }
    }
  }
}
export const event = new Event()
